import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import { useTranslation } from 'react-i18next';
import HiddenIcon from '@wix/da-ds/pkg/Icons/32x32/Hidden';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import HiddenLayout from './HiddenLayout';
const MatureAgeBlockedOverlay = (_param)=>{
    var { deviation , overrideMatureFilter  } = _param, props = _object_without_properties(_param, [
        "deviation",
        "overrideMatureFilter"
    ]);
    const { t  } = useTranslation();
    return /*#__PURE__*/ React.createElement(HiddenLayout, _extends({
        deviation: deviation,
        icon: /*#__PURE__*/ React.createElement(HiddenIcon, {
            size: IconSize.HUGE
        }),
        text: t('deviationview.blocked.mature.text')
    }, props));
};
MatureAgeBlockedOverlay.displayName = 'MatureAgeBlockedOverlay';
export default MatureAgeBlockedOverlay;
